import { Skeleton } from '@nextui-org/react';

const SkeletonSubscription = () => {
  const arr = Array.from(Array(3).keys());

  return (
    <div className="main-container flex flex-col pt-[3%]">
      <div className="flex flex-col items-center">
        <Skeleton className="mt-10 h-[60px] w-[800px] rounded-[28px] xl:w-[90%] md:mt-5" />
        <Skeleton className="my-5 h-[60px] w-[300px] rounded-[28px] md:w-[50%]" />
      </div>
      <div className="-mx-[10px] flex flex-wrap justify-center md:mt-[6%]">
        {arr.map((item) => (
          <>
            <div
              key={item}
              className="w-[calc(100%/3)] max-w-[380px] px-[10px] pb-[20px] lg:w-[50%] sm:!w-full  "
            >
              <div className="overflow-hidden rounded-[28px] bg-white shadow-[0px_4px_8px_4px_rgba(199,205,231,0.25)]">
                <Skeleton className="h-[400px] w-full rounded-t-[28px]" />
              </div>
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default SkeletonSubscription;
